import React, { useEffect, useState } from "react";
import CustomCard from "../../../components/Common/CustomCard";
import { getPlanSpecificationDetails } from "../../../store/menu/home/actions";
import { useDispatch, useSelector } from "react-redux";
import withRouter from "../../../components/Common/withRouter";
import { createSelector } from "reselect";
import CustomLoader from "../../../components/Common/CustomLoader";
import ContentPopup, { billingContent } from "./helper/ContentPopup";
import moment from "moment";
import CustomPopup from "../../../components/Common/CustomPopup";
import { Link, useNavigate } from "react-router-dom";
import CrossIcon from "../../../assets/images/lystfacelogos/CrossIcon.svg"
import { isNotNullOrUndefined } from "../../../common/functions";

const PlanSpecificationDescription = ({ planDetails, loading, responseMessage, responseStatus, planAddLoading }) => {
    const { status } = useSelector(state => state.Login.constDetails)

    const plansList = [
        { 'title': 'Plan name', 'subtitle': `${planDetails?.plan?.plan_name} ${planDetails?.trial_act ? "(Free trial)" : ""}` },
        { 'title': 'Next billing date', 'subtitle': (planDetails?.status ? planDetails?.status : status).length === 0 ? "-" : moment(planDetails?.next_bill_dt).format("DD MMM YYYY"), removed: (!planDetails?.trial_act && !planDetails?.active) && !((planDetails?.status ? planDetails?.status : status).length === 0) },
        { 'title': 'Max transactions limit/min', 'subtitle': `${planDetails?.plan?.specification?.trans_per_min} Transactions` },



    ]
    const trailPlan = [
        { 'title': 'Trial ends', 'subtitle': `${moment(planDetails?.trial_end_dt).format("DD MMM YYYY")}` },
        { 'title': 'Trial API call', 'subtitle': `${planDetails?.trial?.trial_api_call}` },
        { 'title': 'Trial limit exceeded', 'subtitle': `${planDetails?.trial?.trial_limi_exc}` }

    ]
    return (
        <div className={`plan-specification-description-container ${loading || !planDetails?.plan?.plan_name || responseStatus === "Error" ? 'loader-alignment' : ''}`}>
            {
                responseStatus === "Error" ?
                    <span>{responseMessage}</span>
                    :
                    loading || planAddLoading ?
                        <CustomLoader text={"Fetching plan details...."} />
                        :
                        planDetails?.status === "cancelled" ?
                            <div className="no-data">
                                <span>No active plan</span>
                            </div>
                            :
                            planDetails?.plan?.plan_name ?
                                <>
                                    {planDetails?.trial_act &&
                                        <div className="plan-details-container">
                                            {trailPlan.map((ele, i) =>
                                                <div className="plan-specification-field" key={i}>
                                                    <span className="title">{ele.title}</span>
                                                    <span className="subtitle">{ele.subtitle}</span>
                                                </div>

                                            )}
                                        </div>}
                                    <div className="plan-details-container">
                                        {plansList.map((ele, i) =>
                                            (!ele?.removed) &&
                                            <div className={`plan-specification-field `} key={i}>
                                                <span className="title">{ele.title}</span>
                                                <span className="subtitle">{ele.subtitle}</span>
                                            </div>



                                        )}
                                    </div>
                                    {((isNotNullOrUndefined(planDetails?.plan_cancel_dt) || planDetails?.downSchedule)) &&
                                        <div className="validation-message-container pricing">
                                            <div className="messsage-container">
                                                <span className="message">{planDetails?.downSchedule ? `Your plan change to ${planDetails?.upcomingPlan?.plan_name} is scheduled and will
                                                take effect on the next billing cycle.`: "Your plan has been scheduled for cancellation and will take effect on the next billing cycle."}</span>
                                            </div>
                                            <div className="actions-container">
                                                <Link className="link" to={"/settings/billing-details?tab=overview"}>Review Plan</Link>
                                            </div>

                                        </div>
                                    }
                                </>

                                :
                                <div className="empty-list-view">
                                    <img src={"https://img-assets.lystface.com/web/NoAppIcon.svg"} />
                                </div>

            }

        </div>
    )

}

const PlanSpecification = () => {
    const dispatch = useDispatch()
    const HomeMenuUserState = state => state.Home
    const HomeMenuProperties = createSelector(
        HomeMenuUserState,
        HomeMenuDetails => ({
            plan: HomeMenuDetails?.planSpecificationDetails?.plan,
            responseMessage: HomeMenuDetails?.planSpecificationDetails?.responseMessage,
            responseStatus: HomeMenuDetails?.planSpecificationDetails?.responseStatus,
            loading: HomeMenuDetails?.planSpecificationDetails?.loading,

        })
    )
    const { plan, loading, responseMessage, responseStatus } = useSelector(
        HomeMenuProperties
    )
    const PlanUserState = useSelector(state => state.Plan)
    const { planAddLoading } = PlanUserState
    const navigate = useNavigate();


    useEffect(() => {
        if (!planAddLoading) {
            dispatch(getPlanSpecificationDetails({}))
        }
    }, [planAddLoading])



    const handleChangePlan = () => {
        navigate("/settings/pricing")
    }

    const buttonDetails = [
        { 'buttonText': plan?.status === "cancelled" ? "Choose plan" : 'Change plan', path: "/settings/pricing", buttonType: 'secondary', callBackFunction: () => handleChangePlan() }
    ]


    return (
        <React.Fragment>
            <CustomCard
                titleText={"Overview"} Overview
                IsPrimaryButtonDisabled={isNotNullOrUndefined(plan?.plan_cancel_dt) || plan?.downSchedule}
                buttonsList={buttonDetails}>
                <PlanSpecificationDescription planAddLoading={planAddLoading} planDetails={plan} loading={loading} responseMessage={responseMessage} responseStatus={responseStatus} />
            </CustomCard>


        </React.Fragment>
    );
};

export default withRouter(PlanSpecification);